import { Component, OnDestroy, OnInit, Input, HostListener } from '@angular/core';
import { OB } from '../../../areas/admin/full-transcript/pages/ob-report/ob.namespace';
import { takeUntil, finalize } from 'rxjs/operators';
import { Page, IUserAccount, PatientProfile, IEncounterResource } from '../../models';
import { HttpService, AppData, EncounterCommunication, TimelineToggleService } from '../../services';
import { ObEncounter } from "@shared/models/ob-encounter.model";
import { Appointment, PreviousAppointment } from '../../entities';
import { ApiResources } from '../../helpers';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { GYN } from '../../../areas/admin/gyn-encounter/gyn.namespace';

@Component({
    selector: 'dynamic-header',
    templateUrl: './dynamic-header.html',
    styleUrls: ['./dynamic-header.css']
})
export class DynamicHeaderComponent implements OnDestroy, OnInit {
    @Input() patientId: string;
    @Input() appointmentId: string;
    @Input() encounterType: string;
    @Input() sectionId: any;
    @Input() encounterId: any;
    @Input() TemplateId: any;

    ancCards: OB.AncCards;
    page: Page;
    // encryptedPatientId: any;
    isAdmission: any;
    // appointmentId: any;


    obEncounter: ObEncounter;
    appointments: any;
    oldAppointment: any;
    vitals: any;
    allergies: OB.Allergies;
    allergiesdata: IEncounterResource;
    antinantalRisk: OB.AntinantalRisk;
    ancCardGeneration: OB.AncCardGeneration;
    ancVisit: OB.Measure;
    encounterCommunicationSubscription: Subscription;
    appointment: Appointment;
    patAppointment: Appointment;
    ancCardRecord: OB.AncCardGeneration;
    patient: PatientProfile;
    husbandName: string;
    visitNumber: number;
    specialFeature: OB.SpecialFeature;
    ancCardClosed: OB.AncCardClosure;
    visit: number;
    roleId: number;
    commonData: IEncounterResource;
    gplaJson: GYN.NewGynHistory;
    gpla: OB.AncCards;
    sideNav: boolean;
    gacal: any;
    visitRecord: number;
    name: string;
    femaleHistoryDetails:any
    constructor(
        private readonly httpService: HttpService,
        private readonly appData: AppData,
        //private readonly notifyService: NotifyService,
        private readonly encounterCommunication: EncounterCommunication,
        private readonly router: Router,
        public timelineService: TimelineToggleService


    ) {
        this.page = new Page();
        this.eccounterType();

    }

    eccounterType() {
        const url = this.router.url;
        this.encounterType = url.split("/")[url.split("/").length - 4];
    }
    private findAppointment(appointmentId: string) { debugger
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Appointment) => {
                this.appointment = response;
               this. fetchFemaleHistory()
                this.findPatientDetails();
                this.findAncCard();
                this.findDashboard();
                this.paddingTop();
            });
    }
    private findAncCard() {
        const request = {
            patientId: this.appointment.patientId,
            appointmentId: this.appointment.appointmentId,
            isAdmission: this.isAdmission
        }
        this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.fetchANC), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: OB.AncCardGeneration) => {
                this.ancCardRecord = response;
                this.paddingTop();
            });
    }
    private findPatientDetails() {
        this.page.loading = true;
        this.httpService.post<PatientProfile>(ApiResources.getURI(ApiResources.patients.base, ApiResources.patients.profile), { encryptedPatientId: this.appointment.encryptedPatientId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: PatientProfile) => {
                if (response) {
                    this.patient = response;
                    var detaills = this.patient.relativeDetails[0];
                    if (detaills && detaills.relation == "Husband") {
                        this.husbandName = this.patient.relativeDetails[0].fullName
                    }
                }
            });
    }

    private fetchAppointmentCounts() {
        const request = {
            patientId: this.appointment.patientId
        };
        this.httpService.get<number>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findVisitNo), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: number) => {
                this.visit = response;
                if (this.ancCardClosed && this.ancCardClosed.ancCardClosed == 'Yes') {
                    this.visit = 1;
                }
                else if (response == 0) {
                    this.visit = 1;
                }
                else {
                    this.visit = this.ancVisit && this.ancVisit.visitNumber ? this.ancVisit.visitNumber : this.visit;
                }

            });
        this.paddingTop();
    }

    fetchFemaleHistory() {
        debugger
        const request = { PatientId: this.appointment.patientId, SectionID: 790, TemplateId: this.TemplateId, EncounterId: this.appointment.appointmentId };
        this.httpService.post(ApiResources.getURI(ApiResources.sectiondata.base, ApiResources.sectiondata.fetch), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: any) => {
               let data = JSON.parse(response.data)
                this.femaleHistoryDetails = data[0]

            })
    }

    private findDashboard() {
        const request = {
            encryptedAppointmentId: this.appointmentId,
            encryptedProviderId: this.page.userAccount && this.page.userAccount.encryptedReferenceId ? this.page.userAccount.encryptedReferenceId : null,
            encryptedPatientId: this.patientId,
            isAdmission: this.isAdmission
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<[ObEncounter, Appointment, PreviousAppointment]>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findEncounterData), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: [ObEncounter, Appointment, PreviousAppointment]) => {
                this.obEncounter = response["dashboard"];
                this.appointments = response["appointments"];
                this.oldAppointment = response["oldAppointment"];
                if (this.obEncounter && this.obEncounter.obEncounterId) {
                    this.vitals = this.obEncounter.vitals ? JSON.parse(this.obEncounter.vitals) : null;
                    this.antinantalRisk = this.obEncounter.antinantalRisk ? JSON.parse(this.obEncounter.antinantalRisk) : null;
                    this.ancCards = this.obEncounter.ancCard ? JSON.parse(this.obEncounter.ancCard) : null;
                    this.allergies = this.obEncounter.allergies ? JSON.parse(this.obEncounter.allergies) : null;
                    this.ancCardGeneration = this.obEncounter.ancCardGeneration ? JSON.parse(this.obEncounter.ancCardGeneration) : null;
                    this.specialFeature = this.obEncounter.specialFeature ? JSON.parse(this.obEncounter.specialFeature) : null;
                    this.ancCardClosed = this.obEncounter.ancCaredClosure ? JSON.parse(this.obEncounter.ancCaredClosure) : null;
                    this.gpla = this.obEncounter.gpla ? JSON.parse(this.obEncounter.gpla) : null;
                    if (this.ancCards) {
                        if (this.ancCards.lmpStatus == "Unknown") {
                            this.onCalculateGA(this.ancCards.ultraSoundEdd, this.ancCards.lmpStatus);
                        }
                        else {
                            this.onCalculateGA(this.ancCards.lmp, this.ancCards.lmpStatus);
                        }

                    }

                    if (this.obEncounter.ancCardGeneration) {
                        this.husbandName = this.ancCardGeneration.husbandName
                    }
                    this.ancVisit = this.obEncounter.measure ? JSON.parse(this.obEncounter.measure) : null;

                }
              //  this.fetchAppointmentCounts();
                this.paddingTop();
            });
    }

    public onCalculateGA(value: any, lmpStatus?: any) {
        const request = {
            value: value,
            lmpStatus: lmpStatus,
            appointmentDate: this.appointment.appointmentDate
        }
        this.httpService.get(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.calculateGA), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: string) => {
                this.gacal = response;
                this.ancCards.ga = this.gacal;

            });

    }
    toggleIt() {
        this.timelineService.toggle();
        if (this.timelineService.showBox == false) {
            $("body")[0].setAttribute("data-timeline-size", "timelineabsent");
        } else {
            $("body")[0].setAttribute("data-timeline-size", "timeline");
        }
    }
    toggleSideNav() {
        $(".sidebar-main-menu")[0].classList.toggle("removeLeft");
       
        if ($("body")[0].getAttribute('data-sidebar-size') === "default") {
            $('#content-page').removeAttr('style');
            $("body")[0].setAttribute("data-sidebar-size", "condensed");
            $('.encounterBtn-new .mdi-chevron-left').toggleClass('d-none');
            $('.encounterBtn-new .mdi-chevron-right').toggleClass('d-none');
        } else if ($("body")[0].getAttribute('data-sidebar-size') === "condensed") {
            $('#content-page').removeAttr('style');
            $("body")[0].setAttribute("data-sidebar-size", "default");
            $('.encounterBtn-new .mdi-chevron-left').toggleClass('d-none');
            $('.encounterBtn-new .mdi-chevron-right').toggleClass('d-none');
        }
    }
    ngOnInit() {
        debugger
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    const url = this.router.url;
                    this.isAdmission = url.split("/")[4] === "a";
                    this.appointmentId = url.split("/")[url.split("/").length - 3];
                    this.roleId = this.page.userAccount.roleId;
                    this.encounterCommunicationSubscription = this.encounterCommunication.encounter.subscribe(() => {
                        if (this.appointmentId == "b" || this.appointmentId == "a") {
                            var currentUrl = this.router.url;
                            this.appointmentId = currentUrl.split("/")[currentUrl.split("/").length - 4];
                        }
                      
                        this.findCommonData();
                        this.eccounterType();

                    });
                    this.name = this.page.userAccount.fullName;
                } else {
                    this.page.userAccount = undefined;
                }
            });
        this.findAppointment(this.appointmentId);
    }
    @HostListener('window:resize')
    onResize() {
        this.paddingTop();
    }
    @HostListener('window:load')
    onLoad() {
        setTimeout(() => { this.paddingTop(); }, 1500)
    }
    @HostListener('window:hashchange')
    onhashchange() {
        setTimeout(() => { this.paddingTop(); }, 500)
    }
    paddingTop() {
        if (document.getElementById("header") != null && document.getElementsByClassName("content")[0] != null) {
            var paddingTopValue = document.getElementById("header").offsetHeight;
            var content = document.getElementsByClassName("content")[0];
            content.setAttribute('style', `padding-top:${paddingTopValue}px`);
        }
    }
    ngOnDestroy() {
        this.page.unsubscribeAll();
        this.encounterCommunicationSubscription.unsubscribe();
    }



    private findCommonData() {
        const request = {
            encryptedappointmentid: this.appointmentId,
            encryptedpatientid: this.patientId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<IEncounterResource>(ApiResources.getURI(ApiResources.obEncounter.base, ApiResources.obEncounter.findEncounterData), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: IEncounterResource) => {
                this.commonData = response;
                this.gplaJson = this.commonData.jsonString != null ? JSON.parse(this.commonData.jsonString) : null;

            });
    }
    safe = (url: any) => {
        if (url) {
            return `${ApiResources.getURI(ApiResources.resources.base, ApiResources.resources.getProfileImage)}?imagePath=${url}`
        }
    }
}